const moment = require('moment');

export const getStartDate = () => {
    return moment().subtract(1, 'months');
}

export const getEndDate = () => {
    return moment();
}